import api from './api';

// Get all club applications
export const getAllClubApplications = async () => {
    return api.get('/api/sports/club-applications');
};

// Get club application by ID
export const getClubApplicationById = async (id) => {
    return api.get(`/api/sports/club-applications/${id}`);
};

// Update club application status (with optional membershipMonths)
export const updateClubApplicationStatus = async (id, status, notes = '', membershipMonths = null) => {
    const body = { status, notes };
    if (membershipMonths) body.membershipMonths = membershipMonths;
    return api.put(`/api/sports/club-applications/${id}/status`, body);
};

// Delete club application
export const deleteClubApplication = async (id) => {
    return api.delete(`/api/sports/club-applications/${id}`);
};

// Renew membership
export const renewMembership = async (id, membershipMonths) => {
    return api.put(`/api/sports/club-applications/${id}/renew`, { membershipMonths });
};

// Get club time slots
export const getClubTimeSlots = async (id) => {
    return api.get(`/api/sports/club-applications/${id}/time-slots`);
};

// Assign time slot to club
export const assignClubTimeSlot = async (id, data) => {
    return api.post(`/api/sports/club-applications/${id}/time-slots`, data);
};

// Remove time slot assignment
export const removeClubTimeSlot = async (assignmentId) => {
    return api.delete(`/api/sports/club-applications/time-slots/${assignmentId}`);
};

// Get club payment info by tax number
export const getClubPaymentInfo = async (taxNumber, options = {}) => {
    const params = {};
    if (options.clubApplicationId) params.clubApplicationId = options.clubApplicationId;
    if (options.facilityId) params.facilityId = options.facilityId;
    return api.get(`/api/sports/club-applications/payment-info/${taxNumber}`, { params });
};

// Get club payment transaction history
export const getClubPaymentTransactions = async (id) => {
    return api.get(`/api/sports/club-applications/${id}/payment-transactions`);
};


// Transfer a paid but unused session to a future date
export const transferSession = async (data) => {
    return api.post('/api/sports/club-applications/sessions/transfer', data);
};

// Undo a transferred club session and restore its original session
export const removeSessionTransfer = async (transferId) => {
    return api.delete(`/api/sports/club-applications/sessions/transfers/${transferId}`);
};

export const addClubSessionCancellation = async (data) => {
    return api.post('/api/sports/club-applications/sessions/cancellations', data);
};

export const removeClubSessionCancellation = async (id) => {
    return api.delete(`/api/sports/club-applications/sessions/cancellations/${id}`);
};

export const addClubExtraSession = async (data) => {
    return api.post('/api/sports/club-applications/sessions/extra', data);
};

export const removeClubExtraSession = async (id) => {
    return api.delete(`/api/sports/club-applications/sessions/extra/${id}`);
};

// Get unpaid manual debts
export const getClubDebts = async (taxNumber, facilityId) => {
    return api.get(`/api/sports/club-applications/manual-debt?taxNumber=${taxNumber}&facilityId=${facilityId}`);
};

// Add manual debt (Admins only)
export const addClubDebt = async (data) => {
    return api.post(`/api/sports/club-applications/manual-debt`, data);
};

// Remove unpaid manual debt (Admins only)
export const removeClubDebt = async (debtId) => {
    return api.delete(`/api/sports/club-applications/manual-debt/${debtId}`);
};
